import api from '../../helpers/api';

export const SingupArtisan = formData =>
  api.post('/auth/signup-artisan', formData);

export const SingupCutomer = formData =>
  api.post('/auth/signup-customer', formData);

export const SignupSupplier = formData =>
  api.post('/auth/signup-supplier', formData);

export const SignupAdmin = formData => api.post('/auth/signup-admin', formData);

export const Login = formData => api.post('/auth/login', formData);

export const getCurrentUser = () => api.get('/users/me');

export const forgotPassword = payload =>
  api.post('/auth/forget-password', payload);

export const resetPassword = (token, password) =>
  api.post(`/auth/forget-password/confirm/${token}`, { password });

export const updateAuthArtisan = body =>
  api.post(`/artisan-staging/update`, { ...body });
export const updateAuthSupplier = body =>
  api.post(`/supplier-staging/update`, { ...body });
export const updateAuthApplicant = body =>
  api.post(`/applicant-staging/update`, { ...body });
export const updateAuthCustomer = body =>
  api.post(`/customer-staging/update`, { ...body });
export const updateUser = (id, body) => api.put(`users/${id}`, { ...body });
export const updateUserSettings = (id, body) =>
  api.put(`users/update-user-settings/${id}`, { ...body });
